export default [
  {name: 'Menos de 5 metros', value: 0},
  {name: 'Más de 5 metros', value: 1},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/length.js